import React, { useEffect, useState } from "react";
import { Dropdown, initTE } from "tw-elements";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ErrorBoundary } from "react-error-boundary";

import { Timeout } from "./components/shared/Timeout";
import HttpService from "./services/HttpService";
import UserService from "./services/UserService";
import BodyClassManager from "./utils/BodyClassManager";
import LoaderBar from "./components/shared/LoaderBar";

import NavBar from "./components/shared/NavBar";
import OffCanvasMenu from "./components/shared/OffCanvas";
// import UserActiveCheck from "./components/introducer/UserActiveCheck"

import "./scss/App.scss";
import "./scss/ErrorBoundary.scss";

const date = () => {
  const date = new Date();
  const year = date.getFullYear();
  return year;
};

function logout() {
  sessionStorage.clear();
  UserService.doLogout();
}

const fetchUserAttributes = async () => {
  const data = await HttpService.put(
    `User/LoggedInUserInfo?realmName=${UserService._kc.realm}`
  );
  return data;
};

function FallbackComponent({ error, resetErrorBoundary }) {
  return (
    <div className="error-boundary-message">
      <h1>An error has occured</h1>
      <p>There was an error loading this page.</p>
      <p>
        If the problem persists please contact {process.env.REACT_APP_COMPANY_NAME} Client Services on {process.env.REACT_APP_COMPANY_PHONE}
      </p>
      <div className="error-boundary-footer flex flex-nowrap gap-x-1">
        <a href="/" className="primary-btn btn w-1/2 p-2">
          Return to Home Page
        </a>
        <button className="btn w-1/2 p-2" onClick={logout}>
          Please Login Again
        </button>
      </div>
    </div>
  );
}
// Declare TalkdeskChatSDK globally
// let TalkdeskChatSDK;
export default function App() {
  const [userInfo, setUserInfo] = useState(JSON.parse(sessionStorage.getItem("attributeData")) !== undefined ? JSON.parse(sessionStorage.getItem("attributeData")) : null );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    initTE({ Dropdown });

    fetchUserAttributes().then((data) => {
      setUserInfo(data);
      sessionStorage.setItem("attributeData", JSON.stringify(data));
      setIsLoading(false);
    });
  }, []);
  // let TalkdeskChatSDK;
  // useEffect(() => {
  //   // Only initialize Talkdesk if we have user info (or any other condition you need).
  //   if (!userInfo) return;

  //   const nodeId = "tdWebchat";
  //   const props = {
  //     touchpointId: "5d82369413fe42ebb8e6c739331476e8", // Example ID
  //     accountId: "", // Make sure this is correct
  //     region: "td-us-1", // Or td-eu-1 / td-au-1 depending on your account
  //   };
  //   const configs = {
  //     enableValidation: false,
  //     enableEmoji: true,
  //     enableUserInput: true,
  //     enableAttachments: true,
  //     styles: {
  //       chatThemeColor: "#ff0000",
  //       chatTitle: "RedZed Customer Service",
  //       chatSubtitle: " ",
  //       chatPlaceholder: "Type a message...",
  //       avatarForegroundColor: "#5C6784",
  //       avatarBackgroundColor: "#EDF4FC",
  //       userBackgroundColor: "#ff0000",
  //       startChatButtonTextColor: "#FFFFFF",
  //       startChatButtonBackgroundColor: "#ff0000",
  //       chatConfirmButtonBackgroundColor: "#ff0000",
  //     },
  //   };

  //   // Avoid double-injecting the script if it already exists
  //   if (document.getElementById("tdwebchatscript")) {
  //     console.warn("Talkdesk Chat script already loaded. Skipping injection.");
  //     return;
  //   }

  //   // Create a container for the widget
  //   const divContainer = document.createElement("div");
  //   divContainer.id = nodeId;
  //   document.body.appendChild(divContainer);

  //   // Inject the TalkdeskChatSDK script
  //   const script = document.createElement("script");
  //   script.type = "text/javascript";
  //   script.charset = "UTF-8";
  //   script.id = "tdwebchatscript";
  //   script.src = "https://talkdeskchatsdk.talkdeskapp.com/talkdeskchatsdk.js";
  //   script.async = true;
  //   document.body.appendChild(script);

  //   // Once the script loads, initialize the chat
  //   script.onload = () => {
  //     if (!window.TalkdeskChatSDK) {
  //       console.error("TalkdeskChatSDK not found in the global scope!");
  //       return;
  //     }

  //     // Initialize the chat widget
  //     const webchat = window.TalkdeskChatSDK(nodeId, props);
  //     window.webchat = webchat; // optionally store in global if desired

  //     webchat.init(configs);

  //     // Helper function to send user context
  //     function setContext() {
  //       webchat.setContextParam({
  //         name: userInfo?.family_name,
  //         customerid: userInfo?.customerid,
  //         email: userInfo?.email,
  //       });
  //     }

  //     // Hook up your event handlers
  //     webchat.onConversationStart = () => {
  //       setContext();
  //     };
  //     webchat.onOpenWebchat = () => {
  //       setContext();
  //     };
  //   };

  //   // Clean up script and container if component unmounts
  //   return () => {
  //     const existingScript = document.getElementById("tdwebchatscript");
  //     if (existingScript) {
  //       document.body.removeChild(existingScript);
  //     }
  //     const existingDiv = document.getElementById(nodeId);
  //     if (existingDiv) {
  //       document.body.removeChild(existingDiv);
  //     }
  //   };
  
  return (
    // }, [userInfo]);
    <div className="App">
      <BodyClassManager />
      {/* <Timeout> */}
        <ToastContainer theme="colored" />
        <header className="App-header mb-5 md:mb-0">
          <NavBar userInfo={userInfo} />
          <OffCanvasMenu />
        </header>
        {UserService.isMigrated() ? (
            <main className="main-container">
              <div className="flex flex-wrap w-full h-[calc(100vh-250px)] items-center justify-center">
                <div className="border-2 rounded-lg bg-light-blue text-center p-8">
                  <h3 className="mb-4 font-bold">Your account has been migrated to our new RedQ customer portal.</h3>
                  <p>You can continue to log in using your existing username and password.</p>
                  <a className="btn primary-btn inline-block mb-4 py-2 px-4" href="https://customer.redq.redzed.com">Click here to log in to RedQ</a>
                  <p>If you need any assistance accessing the new portal, please contact Client Serivces on <a href="tel:1300722462">1300 722 462</a>.</p>
                </div>
              </div>
            </main>
          ) : (
            <main className="main-container">
              {isLoading ? (
                <LoaderBar />
              ) : (
                <>
                  {/* <UserActiveCheck> */}
                  <ErrorBoundary FallbackComponent={FallbackComponent}>
                    <Outlet />
                  </ErrorBoundary>
                  {/* </UserActiveCheck> */}
                </>
              )}
            </main>
          )}
        <footer className="App-footer flex items-center mt-5 md:mt-0 ">
          <p>
            Copyright {date()} {process.env.REACT_APP_COMPANY_LEGAL_NAME}. Australian Credit Licence {process.env.REACT_APP_COMPANY_ACL}. ABN {process.env.REACT_APP_COMPANY_ABN}. All rights reserved
          </p>
        </footer>
      {/* </Timeout> */}
    </div>
  );
}
